import { makeGetApiRequest } from '@common/index'
import createDataContext from './createDataContext'
import axios from 'axios'

interface StateType {
    purchaseListData: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    purchaseListData: []
}

const reducer = (state, action: ActionType) => {

    switch(action.type)
    {
        case 'setConfirmationPendingData': return { ...state, purchaseListData: action.payload }

        default: return state
    }

}

const downloadExcel = dispatch => {

    return async (url: string, callback?: (data) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await makeGetApiRequest(url, {}, 'Keycloak-Authorization', 'Bearer', 'spares');

            let URL = response?.request?.responseURL;
            const a = document.createElement("a")
            a.href = URL
            a.click();

            !!callback ? callback?.(url) : null

        } catch(e)
        {
            console.log('DOWNLOAD EXCEL ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }
    
}

const setConfirmationPendingData = dispatch => {

    return async (variables, getConfirmationPendingData, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            const response = await getConfirmationPendingData({ variables })

            dispatch({ type: 'setConfirmationPendingData', payload: response.data?.getAllPurchaseListsForVendor })

            !!callback ? callback?.(response.data?.getAllPurchaseListsForVendor) : null

        } catch(e)
        {
            console.log('GET CONFIRMATION PENDING DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface ConfirmationPendingInterface {
    state: StateType,
    setConfirmationPendingData: (variables, getConfirmationPendingData, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    downloadExcel: (url: string, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>
}

export const { Context: ConfirmationPendingContext, Provider: ConfirmationPendingProvider } = createDataContext(reducer,
    { setConfirmationPendingData, downloadExcel },
    initialState)
